import React, { useRef, useEffect, useState } from "react";

const SignaturePad = ({ isOpen, onClose, onSave }) => {
    const canvasRef = useRef(null);
    const [drawing, setDrawing] = useState(false);
    const [hasSigned, setHasSigned] = useState(false);

    useEffect(() => {
        if (isOpen) {
            const canvas = canvasRef.current;
            canvas.width = 400;
            canvas.height = 150;
            const ctx = canvas.getContext("2d");
            ctx.lineWidth = 2;
            ctx.strokeStyle = "#000000";
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            setHasSigned(false); // Reset signature status when modal opens
        }
    }, [isOpen]);

    const getOffset = (e) => {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();

        if (e.touches && e.touches.length > 0) {
            return {
                x: e.touches[0].clientX - rect.left,
                y: e.touches[0].clientY - rect.top
            };
        } else {
            return {
                x: e.nativeEvent.offsetX,
                y: e.nativeEvent.offsetY
            };
        }
    };

    const startDrawing = (e) => {
        const { x, y } = getOffset(e);
        const ctx = canvasRef.current.getContext("2d");
        ctx.beginPath();
        ctx.moveTo(x, y);
        setDrawing(true);
    };

    const draw = (e) => {
        if (!drawing) return;
        e.preventDefault(); // Prevent scroll while drawing on mobile
        const { x, y } = getOffset(e);
        const ctx = canvasRef.current.getContext("2d");
        ctx.lineTo(x, y);
        ctx.stroke();
        setHasSigned(true); // User has drawn something
    };

    const stopDrawing = () => {
        setDrawing(false);
    };

    const clearCanvas = () => {
        const canvas = canvasRef.current;
        canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
        setHasSigned(false);
    };

    const saveSignature = () => {
        if (!hasSigned) {
            alert("Please sign before saving.");
            return;
        }

        const dataUrl = canvasRef.current.toDataURL("image/png");
        onSave(dataUrl);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div style={modalStyles.overlay}>
            <div style={modalStyles.modal}>
                <h3>Sign Here</h3>
                <canvas
                    ref={canvasRef}
                    onMouseDown={startDrawing}
                    onMouseMove={draw}
                    onMouseUp={stopDrawing}
                    onMouseLeave={stopDrawing}
                    onTouchStart={startDrawing}
                    onTouchMove={draw}
                    onTouchEnd={stopDrawing}
                    style={{ border: "1px solid #ccc", cursor: "crosshair", touchAction: "none" }}
                />
                <div style={{ marginTop: 10 }}>
                    <button onClick={clearCanvas}>Clear</button>
                    <button onClick={saveSignature} style={{ marginLeft: 10 }}>Save</button>
                    <button onClick={onClose} style={{ marginLeft: 10 }}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

const modalStyles = {
    overlay: {
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 1000
    },
    modal: {
        background: "#fff",
        padding: 20,
        borderRadius: 8,
        boxShadow: "0 0 10px rgba(0,0,0,0.25)",
        textAlign: "center"
    }
};

export default SignaturePad;
